export interface VehicleRecord {
  segment: string;
  segmentCode: string;
  model: string;
  variant: string;
  range: number;
  batteryCapacity: number;
  efficiency: number;
  unitPrice: number;
  costPerKm: number;
  iceMileagePerUnit: number;
  unitCost: number;
  iceCostPerKm: number;
}

export const VEHICLE_DATA: VehicleRecord[] = [
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Auto',
    variant: 'ePL 2.0R',
    range: 160,
    batteryCapacity: 10.6,
    efficiency: 0.0663,
    unitPrice: 10,
    costPerKm: 0.663,
    iceMileagePerUnit: 27,
    unitCost: 90,
    iceCostPerKm: 3.33,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Cargo',
    variant: 'eCX',
    range: 160,
    batteryCapacity: 13.8,
    efficiency: 0.0844,
    unitPrice: 10,
    costPerKm: 0.844,
    iceMileagePerUnit: 33,
    unitCost: 90,
    iceCostPerKm: 2.73,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Cargo',
    variant: 'eCX d',
    range: 140,
    batteryCapacity: 13.8,
    efficiency: 0.0844,
    unitPrice: 10,
    costPerKm: 0.844,
    iceMileagePerUnit: 33,
    unitCost: 90,
    iceCostPerKm: 2.73,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Cargo',
    variant: 'eCX d+',
    range: 140,
    batteryCapacity: 13.8,
    efficiency: 0.0844,
    unitPrice: 10,
    costPerKm: 0.844,
    iceMileagePerUnit: 33,
    unitCost: 90,
    iceCostPerKm: 2.73,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Cargo',
    variant: 'eQX',
    range: 110,
    batteryCapacity: 10.24,
    efficiency: 0.0931,
    unitPrice: 10,
    costPerKm: 0.931,
    iceMileagePerUnit: 33,
    unitCost: 90,
    iceCostPerKm: 2.73,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'Super Cargo',
    variant: 'eQX d+',
    range: 100,
    batteryCapacity: 10.24,
    efficiency: 0.1024,
    unitPrice: 10,
    costPerKm: 1.024,
    iceMileagePerUnit: 33,
    unitCost: 90,
    iceCostPerKm: 2.73,
  },
  {
    segment: '3W',
    segmentCode: 'VC03',
    model: 'eRick',
    variant: '',
    range: 0,
    batteryCapacity: 0,
    efficiency: 0,
    unitPrice: 0,
    costPerKm: 0,
    iceMileagePerUnit: 0,
    unitCost: 0,
    iceCostPerKm: 0,
  },

  {
    segment: 'SCV',
    segmentCode: 'VC04',
    model: 'Eviator',
    variant: 'E350X FSD V2',
    range: 180,
    batteryCapacity: 43.2,
    efficiency: 0.2541,
    unitPrice: 10,
    costPerKm: 2.541,
    iceMileagePerUnit: 12,
    unitCost: 90,
    iceCostPerKm: 7.5,
  },
  {
    segment: 'SCV',
    segmentCode: 'VC04',
    model: 'Eviator',
    variant: 'E350L CBC V2',
    range: 180,
    batteryCapacity: 43.2,
    efficiency: 0.2541,
    unitPrice: 10,
    costPerKm: 2.541,
    iceMileagePerUnit: 12,
    unitCost: 90,
    iceCostPerKm: 7.5,
  },
  {
    segment: 'SCV',
    segmentCode: 'VC04',
    model: 'Eviator',
    variant: 'E350L FSD V2',
    range: 180,
    batteryCapacity: 43.2,
    efficiency: 0.2541,
    unitPrice: 10,
    costPerKm: 2.541,
    iceMileagePerUnit: 12,
    unitCost: 90,
    iceCostPerKm: 7.5,
  },
  {
    segment: 'SCV',
    segmentCode: 'VC04',
    model: 'Eviator',
    variant: 'E350L FSD V4',
    range: 180,
    batteryCapacity: 43.2,
    efficiency: 0.2541,
    unitPrice: 10,
    costPerKm: 2.541,
    iceMileagePerUnit: 12,
    unitCost: 90,
    iceCostPerKm: 7.5,
  },
  {
    segment: 'SCV',
    segmentCode: 'VC04',
    model: 'Eviator',
    variant: 'E350L CBC V1',
    range: 180,
    batteryCapacity: 43.2,
    efficiency: 0.2541,
    unitPrice: 10,
    costPerKm: 2.541,
    iceMileagePerUnit: 12,
    unitCost: 90,
    iceCostPerKm: 7.5,
  },
  {
    segment: 'Tractor',
    segmentCode: 'VC02',
    model: 'E-27',
    variant: '27HP',
    range: 3,
    batteryCapacity: 22.3,
    efficiency: 0,
    unitPrice: 10,
    costPerKm: 74.33,
    iceMileagePerUnit: 1,
    unitCost: 90,
    iceCostPerKm: 225.0,
  },
  {
    segment: 'Tractor',
    segmentCode: 'VC02',
    model: 'E-40',
    variant: '40HP',
    range: 0,
    batteryCapacity: 0,
    efficiency: 0,
    unitPrice: 0,
    costPerKm: 0,
    iceMileagePerUnit: 0,
    unitCost: 0,
    iceCostPerKm: 0,
  },

  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 5536e',
    variant: '6X4TT Lite',
    range: 95,
    batteryCapacity: 129,
    efficiency: 1.3579,
    unitPrice: 10,
    costPerKm: 13.579,
    iceMileagePerUnit: 3,
    unitCost: 90,
    iceCostPerKm: 30.0,
  },
  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 5536e',
    variant: '6X4TT',
    range: 185,
    batteryCapacity: 258,
    efficiency: 1.3946,
    unitPrice: 10,
    costPerKm: 13.946,
    iceMileagePerUnit: 3,
    unitCost: 90,
    iceCostPerKm: 30.0,
  },
  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 5538e',
    variant: '6X4TT',
    range: 205,
    batteryCapacity: 282,
    efficiency: 1.3756,
    unitPrice: 10,
    costPerKm: 13.756,
    iceMileagePerUnit: 3,
    unitCost: 90,
    iceCostPerKm: 30.0,
  },
  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 5538ev',
    variant: '6X4TT',
    range: 205,
    batteryCapacity: 282,
    efficiency: 1.3756,
    unitPrice: 10,
    costPerKm: 13.756,
    iceMileagePerUnit: 3,
    unitCost: 90,
    iceCostPerKm: 30.0,
  },
  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 5538ev',
    variant: '4X2TT',
    range: 205,
    batteryCapacity: 282,
    efficiency: 1.3756,
    unitPrice: 10,
    costPerKm: 13.756,
    iceMileagePerUnit: 3,
    unitCost: 90,
    iceCostPerKm: 30.0,
  },
  {
    segment: 'Truck',
    segmentCode: 'VC01',
    model: 'Rhino 2838ev',
    variant: '6X4T',
    range: 0,
    batteryCapacity: 0,
    efficiency: 0,
    unitPrice: 0,
    costPerKm: 0,
    iceMileagePerUnit: 0,
    unitCost: 0,
    iceCostPerKm: 0,
  },
];

export const VEHICLE_TYPES_MASTER = [
  { label: 'Truck', value: 'Truck', segmentCode: 'VC01' },
  { label: 'Tractor', value: 'Tractor', segmentCode: 'VC02' },
  { label: '3W', value: '3W', segmentCode: 'VC03' },
  { label: 'SCV', value: 'SCV', segmentCode: 'VC04' },
];
